import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/20/solid";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * A wizard step's buttons: Previous and Cancel on the left, the forward action
 * on the right. Without `onNext` the forward button submits the step's form.
 */
const StepActions: React.FunctionComponent<{
  onPrevious?: () => void;
  onCancel: () => void;
  onNext?: () => void;
  nextLabel?: React.ReactNode;
  nextDisabled?: boolean;
}> = ({ onPrevious, onCancel, onNext, nextLabel, nextDisabled = false }) => {
  const { t } = useTranslation();

  return (
    <footer className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-gray-200 pt-4">
      <div className="flex flex-wrap gap-2">
        {onPrevious ? (
          <button
            type="button"
            className="btn-default inline-flex items-center gap-1.5 text-sm font-semibold"
            onClick={onPrevious}
          >
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" />
            {t("common.prev_step")}
          </button>
        ) : null}
        <button
          type="button"
          className="btn-default text-sm font-semibold"
          onClick={onCancel}
        >
          {t("common.cancel")}
        </button>
      </div>
      <button
        type={onNext ? "button" : "submit"}
        className="btn-primary ml-auto inline-flex items-center gap-1.5 text-sm font-semibold"
        onClick={onNext}
        disabled={nextDisabled}
      >
        {nextLabel ?? t("common.next_step")}
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
      </button>
    </footer>
  );
};

export default StepActions;
